import { render, staticRenderFns } from "./ProjectManagementPage.vue?vue&type=template&id=18425020&"
import script from "./ProjectManagementPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectManagementPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports